import { ApplicantsTableColumns } from '../types/ApplicantsTable';
import { SearchCandidatesItem } from 'modules/analyse/types/SearchCandidatesItem';
import { getAnalysisTitle } from 'utils/getAnalysisTitle';

export const mapApplicantsDataToTableColumns = (
  data: SearchCandidatesItem[]
): ApplicantsTableColumns[] =>
  data.map((item) => ({
    id: item.id,
    createdAt: item.createdAt,
    applicantName: `${item.firstName} ${item.lastName}`,
    jobTitle: getAnalysisTitle(item.candidateBatch),
    jobReference: item.candidateBatch?.atsJobReference || '-',
    status: item.status || '',
    isAllRequirementsMet: item.isAllRequirementsMet || false,
    score: item.totalScoreScaled ?? null,
    analysisErrorCode: item.analysisErrorCode ?? null,
    atsApplicationSource: item.atsApplicationSource || null,
    candidateBatchId: item.candidateBatchId || '',
    candidateBatchStatus: item.candidateBatch?.status || '',
    candidateBatchGroupId: item.candidateBatch?.candidateBatchGroupId || null,
    origin: item.origin || ''
  }));
